<template>
  <div class="ly-box">
    <div class="ly-house" @click="chooseHouse">
      <div class="icon-address"></div>
      <div class="house-name">{{house}}
        <div class="hMore"></div>
      </div>
    </div>
    <div class="ly-banner">
      <yd-slider autoplay="3000" pagination-color="#FFFFFF">
        <yd-slider-item v-for="(banner,index) in banners" :key="index">
          <a href="javascript:;">
            <img :src="banner">
          </a>
        </yd-slider-item>
      </yd-slider>
    </div>
    <div class="ly-info">
      <div v-for="item in server" :key="item.id" class="boxs-item">
        <div slot="else" @click="getAuthCode(item.url)">
          <div class="icon" :style="{backgroundImage: 'url(' + item.icon + ')', backgroundSize:'contain'}"></div>
          <p>{{item.name}}</p>
        </div>
      </div>
    </div>


    <div class="pop" v-show="isPop">
      <div class='popContent'>
        <div class="pop-body">
          <div class="pop-list">
            <div class="list-item" :key="index" v-for="(house,index) in housings"
                 @click="handleChoose(house)">
              <div :class="dfHouse.name==house.name?'active':'name'">{{house.name}}</div>
            </div>
          </div>
        </div>
        <div style="text-align: center;" class="pop-foot">
          <yd-button class="cancel" bgcolor="#fff" color="#007aff" type="disabled" @click.native="handleCancel">取消
          </yd-button>
        </div>
      </div>
    </div>


    <!--<footbar :one="false" :two="true" :three="false"></footbar>-->
    <yd-tabbar fixed active-color="#13B6A5" style="padding:4px 0;border-top: 1px solid #DCDCDC;" bgcolor="#F0F0F0">
      <yd-tabbar-item title="服务" active>
        <img src="../assets/aAt.png" alt="" slot="icon" style="height: 0.54rem;">
      </yd-tabbar-item>
      <yd-tabbar-item title="社区" link="/community">
        <img src="../assets/b.png" alt="" slot="icon" style="height: 0.54rem;">
      </yd-tabbar-item>
      <yd-tabbar-item title="我的" link="/user/info">
        <img src="../assets/c.png" alt="" slot="icon" style="height:0.54rem;">
      </yd-tabbar-item>
    </yd-tabbar>
  </div>
</template>

<script>
  import http from "../http";
  import storage from "../store/storage.js";
  // import footbar from "./footbar/footbar"

  export default {
    // components: {
    //   footbar
    // },
    data() {
      return {
        server: {},
        //默认小区相关
        isPop: false,
        house: '',
        dfHouse: '',
        housings: [],
        banners: []
      };
    },
    created: function () {
      this.init();
    },
    methods: {
      // 请求数据
      init: function () {
        let params = {
          appId: storage.get("appId", 'local'),
          type: 1,
        };
        // params.appId = storage.get("appId", 'local');
        http.post("/common/getIcons", params).then(res => {
          const hasHouse = storage.get("housingId", 'local');
          //如果缓存里面有了房间信息则用缓存信息
          if (hasHouse) {
            this.house = storage.getObj("housingId", 'local').name;
            this.active = storage.getObj("housingId", 'local').id;
            this.dfHouse = storage.getObj("housingId", 'local')
          } else {
            this.isPop = true
            // if (res.data.housings && res.data.housings.length > 0) {
            //   this.house = res.data.housings[0].name;
            //   this.active = res.data.housings[0].id;
            //   this.dfHouse = res.data.housings[0]
            //   storage.put("housingId", res.data.housings[0]);
            // } else {
            //   this.$dialog.toast({
            //     mes: '暂无小区信息',
            //     timeout: 1500,
            //     icon: 'error',
            //   });
            // }
          }
          this.housings = res.data.housings;
          this.server = res.data.apps;
          this.banners = res.data.banners;

        });
      },
      handleChoose: function (house) {
        this.house = house.name;
        this.active = house.id;
        this.dfHouse = house;
        storage.put("housingId", house, 'local')
        this.isPop = false;
      },
      chooseHouse: function () {
        this.dfHouse = storage.getObj("housingId", "local");
        this.isPop = true;
      },
      getAuthCode: function (url) {
        console.log(url)
        if ('' != url && null != url) {
          window.location.href = url;
        } else {
          this.$dialog.toast({
            mes: '请联系管理员开通功能',
            timeout: 1500,
            icon: 'error',
          });
        }
      },
      handleCancel: function () {
        if (!storage.getObj("housingId", "local")) {
          this.$dialog.toast({
            mes: '请选择小区',
            timeout: 1500,
            icon: 'error',
          });
          return
        }
        this.isPop = false
      }
    }
  }
  ;
</script>

<style>
  body {
    background: #fff;
  }

  .ly-box .yd-popup {
    background-color: transparent;
  }
</style>

<style scoped lang="scss">

  .ly-info {
    padding-bottom: 1.2rem;
  }

  .ly-house {
    width: auto;
    height: 0.54rem;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    z-index: 99;
    right: 50%;
    margin-right: -3.5rem;
    border-radius: 0.27rem;
    top: 0.2rem;
    display: flex;
    .icon-address {
      width: 0.54rem;
      height: 0.54rem;
      background-color: rgba(0, 0, 0, 0.6);
      border-radius: 99%;
      overflow: hidden;
      background-image: url(../assets/address.png);
      background-repeat: no-repeat;
      background-position: center 0.12rem;
      background-size: 0.3rem;
    }
    .house-name {
      padding: 0 0.1rem;
      color: #fff;
      line-height: 0.58rem;
      .hMore {
        width: 0.3rem;
        height: 0.1rem;
        background: url(../assets/hMore.png) no-repeat center center;
        background-size: 0.1rem;
        display: inline-block;
        position: relative;
        top: -0.01rem;
      }
    }
  }

  .boxs-item:nth-child(3n) {
    border-right: none;
  }

  .boxs-item {
    width: 33.33%;
    height: 2.25rem;
    display: inline-block;
    border-right: 1px solid #E5E5E5;
    border-bottom: 1px solid #E5E5E5;
    text-align: center;
    .icon {
      width: 0.88rem;
      height: 1.4rem;
      margin: 0 auto;
      background-position: center bottom;
      background-repeat: no-repeat;
    }
    p {
      line-height: 0.64rem;
      font-size: 0.28rem;
      color: #000000;
    }
  }

  /* 规则提示层  */
  .pop {
    height: 100%;
    width: 100%;
    position: fixed;
    background-color: rgba(0, 0, 0, .5);
    z-index: 999;
    top: 0;
    left: 0;
    .popContent {
      width: 6.6rem;
      height: 5.5rem;
      overflow: hidden;
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -3.3rem;
      .pop-body {
        width: 100%;
        height: 4rem;
        overflow: hidden;
        .pop-list {
          width: 100%;
          height: 4rem;
          overflow-y: scroll;
          border-radius: 0.2rem;
          background: #fff;
          .list-item {
            height: 1.1rem;
            border-bottom: 1px solid #e3e4e5;
            .name {
              line-height: 1.1rem;
              text-align: center;
              color: #323232;
              font-size: 0.4rem;
            }
            .active {
              line-height: 1.1rem;
              text-align: center;
              color: #FF3B30;
              font-size: 0.4rem;
            }
          }
        }
      }
      .pop-foot {
        width: 100%;
        height: 1.4rem;
        .cancel {
          margin-top: 0.2rem;
          width: 100%;
          height: 1rem;
          font-size: 0.36rem;
          border-radius: 0.2rem;
          padding: 0;
        }
      }

    }
  }

  /*  end  */
</style>



// WEBPACK FOOTER //
// src/components/index.vue